<template>
    <div
        class="tw-flex tw-flex-row tw-justify-between tw-text-center tw-items-center"
    >
        <span>How many guests are joining?</span
        ><SelectUsersSpotCount
            :value="props.value"
            @input="(val) => emit('input', val)"
            :max="maxBookSpot"
            :min="0"
        ></SelectUsersSpotCount>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { ClassSignup } from '../../../components/bookclass/types/classSignupType'
import type {
    Package,
    StudioClass,
} from '../../../components/bookclass/types/types'
import SelectUsersSpotCount from './SelectUsersSpotCount.vue'
const props = defineProps<{
    value: number
    selectedPackage?: Package
    userBookedSpots: ClassSignup[]
    studioClass: StudioClass
}>()
const emit = defineEmits<{
    (e: 'input', value: number): void
}>()

const countBookedWithSelectedPackage = computed(() => {
    const totalBookedSpots = props.userBookedSpots.filter((spot) => {
        return spot.packageId === props.selectedPackage?.id
    })

    return totalBookedSpots.length
})

const classCreditCost = computed(() => {
    return props.studioClass.numCredits ?? 1
})

const spotsFromCredit = computed(() => {
    return Math.floor(
        (props.selectedPackage?.classesLeft ?? 0) / classCreditCost.value
    )
})

const totalBooked = computed(() => {
    return Math.max(
        0,
        (props.selectedPackage?.numGroupBookable ?? 0) -
            countBookedWithSelectedPackage.value
    )
})
const maxBookSpot = computed(() => {
    return Math.min(totalBooked.value, spotsFromCredit.value)
})
</script>
